import _ from 'lodash';
import PropertyDetails from '@/app/modules/toolkit/covid/modules/rent-relief/components/property-details/property-details.vue';
import RentReliefDetermination from '@/app/modules/toolkit/covid/modules/rent-relief/components/rent-relief-determination/rent-relief-determination.vue';
import RentReliefOutcome from '@/app/modules/toolkit/covid/modules/rent-relief/components/rent-relief-outcome/rent-relief-outcome.vue';
import RentReliefDrivers from '@/app/modules/toolkit/covid/modules/rent-relief/components/rent-relief-drivers/rent-relief-drivers.vue';
import RentReliefAdjustments from '@/app/modules/toolkit/covid/modules/rent-relief/components/rent-relief-adjustments/rent-relief-adjustments.vue';
import RentReliefReductionContainer from '@/app/modules/toolkit/covid/modules/rent-relief/containers/covid-rent-relief-reduction-container/covid-rent-relief-reduction-container.vue';
import RentReliefLandlord from '@/app/modules/toolkit/covid/modules/rent-relief/components/rent-relief-landlord/rent-relief-landlord.vue';
import RentReliefReview from '@/app/modules/toolkit/covid/modules/rent-relief/components/rent-relief-review/rent-relief-review.vue';
import { types } from '@/app/filters/filters';

export default {
  name: 'covid-rent-relief-container',
  components: {
    PropertyDetails,
    RentReliefDetermination,
    RentReliefOutcome,
    RentReliefDrivers,
    RentReliefAdjustments,
    RentReliefReductionContainer,
    RentReliefLandlord,
    RentReliefReview,
  },
  data: () => ({
    devMode: process.env.NODE_ENV,
    currentStep: 0,
    currentChildStep: 0,
    stepperData: {
      title: 'Rent Relief',
      style: 'blue',
      steps: [
        {
          step: 1,
          name: 'Property Details',
          component: 'property-details',
        },
        {
          step: 2,
          name: 'Rent Relief Determination',
          children: [
            {
              component: 'rent-relief-determination',
            },
            {
              component: 'rent-relief-outcome',
            },
          ],
        },
        {
          step: 3,
          name: 'Rent Adjustments',
          children: [
            {
              component: 'rent-relief-drivers',
            },
            {
              component: 'rent-relief-adjustments',
            },
            {
              component: 'rent-relief-reduction-container',
            },
            {
              component: 'rent-relief-landlord',
            },

          ],
        },
        {
          step: 4,
          name: 'Rent Relief Review',
          component: 'rent-relief-review',
        },
      ],
    },
  }),
  computed: {
    currentComponent() {
      const currentStep = this.stepperData.steps[this.currentStep];
      if (this.currentStepHasChild) {
        return currentStep.children[this.currentChildStep].component;
      }
      return currentStep.component;
    },
    currentStepHasChild() {
      const currentStep = this.stepperData.steps[this.currentStep];
      return Object.prototype.hasOwnProperty.call(currentStep, 'children');
    },
    rentRelief() {
      return this.$store.getters['toolkit/getItem'];
    },
    isComplete() {
      return this.rentRelief.status === 'COMPLETE';
    },
  },
  methods: {
    saveCovid() {
      // eslint-disable-next-line no-unused-vars
      this.$store.dispatch('toolkit/saveItem').catch((err) => {});
    },
    handleStepChange(step) {
      this.$mixpanel.track('Toolkit Item', {
        status: types(this.rentRelief.status),
        type: this.rentRelief.type,
        context: 'Item Step',
        step: this.stepperData.steps[this.currentStep].name,
        action: 'Step',
        uuid: this.rentRelief.uuid,
      });
      if (typeof step === 'number') {
        this.currentStep = step;
      } else if (_.isArray(step)) {
        [this.currentStep, this.currentChildStep] = step;
      }
      this.$nextTick(() => {
        this.$refs.container.scrollIntoView();
      });
    },
    handleBackStep() {
      this.$mixpanel.track('Toolkit Item', {
        status: types(this.rentRelief.status),
        type: this.rentRelief.type,
        context: 'Item Step',
        step: this.stepperData.steps[this.currentStep].name,
        action: 'Back',
        uuid: this.rentRelief.uuid,
      });
      if (this.currentStepHasChild) {
        if (this.currentChildStep > 0) {
          this.currentChildStep -= 1;
        } else {
          this.currentStep -= 1;
          if (this.currentStepHasChild) {
            const currentStep = this.stepperData.steps[this.currentStep];
            this.currentChildStep = currentStep.children.length - 1;
          }
        }
      } else {
        this.currentStep -= 1;
        this.currentChildStep = 0;
        if (this.currentStepHasChild) {
          const currentStep = this.stepperData.steps[this.currentStep];
          this.currentChildStep = currentStep.children.length - 1;
        }
      }
      this.saveCovid();
      this.$nextTick(() => {
        this.$refs.container.scrollIntoView();
      });
    },
    handleNextStep() {
      this.$mixpanel.track('Toolkit Item', {
        status: types(this.rentRelief.status),
        type: this.rentRelief.type,
        context: 'Item Step',
        step: this.stepperData.steps[this.currentStep].name,
        action: 'Next',
        uuid: this.rentRelief.uuid,
      });
      const currentStep = this.stepperData.steps[this.currentStep];
      if (this.currentStepHasChild) {
        if (currentStep.children.length - 1 > this.currentChildStep) {
          this.currentChildStep += 1;
        } else {
          this.currentChildStep = 0;
          this.currentStep += 1;
        }
      } else {
        this.currentStep += 1;
      }
      this.saveCovid();
      this.$nextTick(() => {
        this.$refs.container.scrollIntoView();
      });
    },
    handleFinalise() {
      this.currentStep = 3;
      this.saveCovid();
      this.$nextTick(() => {
        this.$refs.container.scrollIntoView();
      });
    },
  },
};
